import { UserType } from '@shared/enums/user-type';
import { WorkflowStepEnumType } from '@shared/enums/workflow-step.enum';
import { RestWorkflowStepAssignmentModel } from '@shared/interfaces/rest-workflow-step-assignment-model.interface';
import { RestWorkflowInstanceModel } from '@shared/interfaces/turnover.interface';
import { UserData } from '@shared/interfaces/user-data';

export function UpdateWorkflowStepAssigneeModelFunction(
  workflow: RestWorkflowInstanceModel[],
  workflowStep: WorkflowStepEnumType,
  workflowStepAssignmentModel: RestWorkflowStepAssignmentModel,
  userData?: UserData
): RestWorkflowInstanceModel[] {
  return workflow.map<RestWorkflowInstanceModel>(item => {
    if (item.workflowStepEnumType === workflowStep) {
      return {
        ...item,
        responsiblePartyId: workflowStepAssignmentModel?.responsiblePartyId || userData?.id || 0,
        responsiblePartyType:
          workflowStepAssignmentModel?.responsiblePartyGroupType || userData?.userType || UserType.None,
      };
    } else {
      return item;
    }
  });
}
